var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.2993C6.5 7.82031 9.32031 5 12.7993 5C16.2784 5 19.0987 7.82031 19.0987 11.2993C19.0987 13.4176 17.832 15.2131 16.3724 16.4781L13.9637 18.5657C13.2955 19.1448 12.3032 19.1448 11.635 18.5657L9.22625 16.4781C7.7667 15.2131 6.5 13.4176 6.5 11.2993ZM12.7983 12.6981C13.5714 12.6981 14.1981 12.0714 14.1981 11.2983C14.1981 10.5252 13.5714 9.89844 12.7983 9.89844C12.0252 9.89844 11.3984 10.5252 11.3984 11.2983C11.3984 12.0714 12.0252 12.6981 12.7983 12.6981Z",
    fill: "#0A51C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cf3d57d319d9ca92bcb6994fc7279169.svg";
export { ForwardRef as ReactComponent };